const webURL = 'https://tenant.reposit.co.uk';
const clientId = 'FkybhYVGuA3N5xLK2DwfhcjkoAhkVj2j';
const paymentPlanPortalURL = 'https://tenant-portal.reposit.co.uk';

export const appConfig = {
  links: {
    auth0: {
      logout: `https://reposit.eu.auth0.com/v2/logout?client_id=${clientId}`,
      login: `https://reposit.eu.auth0.com/authorize?response_type=token&client_id=${clientId}&redirect_uri=${webURL}/authenticate&audience=https://prod.api.com`,
    },
    local: {
      login: `${webURL}/login`,
    },
    paymentPlanPortal: paymentPlanPortalURL,
  },
  api: {
    basePath: 'https://api.reposit.co.uk',
  },
  analytics: {
    trackers: [
      {
        name: 'live',
        id: 'UA-81451405-4',
      },
    ],
  },
  stripe: {
    apiKey: 'pk_live_1b5NUskHAfiDV4ZX1xUhfeQa',
  },
  intercom: {
    appId: 'qr0917ud',
    enabled: true,
  },
  hotjar: {
    enabled: true,
    siteId: 1742154,
    hotjarVersion: 6,
  },
  trustPilot: {
    repositOfferTrustBoxEnabled: true,
  },
  inMaintenanceMode: false,
  sentry: {
    enabled: true,
    dsn: 'https://333ef1756b19b80d33b90623c88f3795@o4510641285693440.ingest.de.sentry.io/4511139575234640',
    environment: 'production',
    tracesSampleRate: 0.3,
  },
};
